import { ButtonContainer } from "./Button.styles";

const Button = ({
  title,
  onClick,
  leftIcon,
  rightIcon,
  style,
  disabled,
  opacity,
  loading,
  background,
  editTrainingPage,
  textColor,
}) => {
  return loading ? (
    <ButtonContainer style={style} disabled>
      <l-line-spinner size="20" stroke="2" speed="1" color="#000" />
    </ButtonContainer>
  ) : (
    <ButtonContainer
      style={style}
      onClick={onClick}
      disabled={disabled}
      $background={background}
      $textColor={textColor}
      $opacity={opacity}
      $editTrainingPage={editTrainingPage}
    >
      {leftIcon}
      {title}
      {rightIcon}
    </ButtonContainer>
  );
};

export default Button;
